module.exports = __webpack_public_path__ + "img/img_festa3.05723086.jpg";